module.exports = __webpack_public_path__ + "img/gps.eb54d131.svg";